import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Container,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../Assets/G Sports/PNG/Asset 4@4x.png';
import { COLORS } from '../Constants/styles';
import AccentButton from '../Feature/Common/AccentButton';

const pages = [
  { name: 'Home', path: '/home' },
  { name: 'About Us', path: '/about' },
  { name: 'Our Services', path: '/ourservices' },
  { name: 'ChampionsForge', path: '/championsforge' },
  { name: 'Shop', path: '/shop' },
  { name: 'Careers', path: '/careers' },
  { name: 'Contact Us', path: '/contact' },
];

const Navbar: React.FC = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const location = useLocation();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => setAnchorElNav(null);

  return (
    <AppBar
      position="absolute"
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>

          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img src={logo} alt="Grassroots" style={{ height: 40 }} />
            <Typography
              variant="h6"
              component={Link}
              to="/"
              sx={{
                ml: 1,
                fontWeight: 700,
                color: COLORS.white,
                textDecoration: 'none',
                fontFamily: "'Big Shoulders Text', sans-serif",
                fontSize: '20px',
                textTransform: 'uppercase',
                lineHeight: '1.2rem',
                letterSpacing: '1px',
              }}
            >
              Grassroots Sports
            </Typography>
          </Box>

          {/* Desktop Nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, alignItems: 'center' }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                component={Link}
                to={page.path}
                sx={{
                  fontFamily: "'Big Shoulders Text', sans-serif",
                  fontWeight: 600,
                  fontSize: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  color: COLORS.white,
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -4,
                    left: 0,
                    width: location.pathname === page.path ? '100%' : '0%',
                    height: '2px',
                    backgroundColor: COLORS.accentLime,
                    transition: 'width 0.3s ease',
                  },
                  '&:hover::after': { width: '100%' },
                  '&:hover': { backgroundColor: 'transparent' },
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          {/* Login button — desktop */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
            <AccentButton label="Login" href="/" />
          </Box>

          {/* Mobile hamburger */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton size="large" onClick={handleOpenNavMenu} sx={{ color: COLORS.white }}>
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              PaperProps={{
                sx: {
                  backgroundColor: COLORS.accentDarkGreen,
                  minWidth: 200,
                },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  sx={{ '&:hover': { backgroundColor: 'rgba(194,252,133,0.1)' } }}
                >
                  <Typography
                    component={Link}
                    to={page.path}
                    sx={{
                      textDecoration: 'none',
                      color: COLORS.white,
                      fontFamily: "'Big Shoulders Text', sans-serif",
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      fontSize: '15px',
                    }}
                  >
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
